import { WORKER_ACTION_TYPES } from '../../actions/worker/worker_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const workers = (state = initialState, action) => {
    switch (action.type) {
        case WORKER_ACTION_TYPES.GET_WORKERS_SUCCESS:
            return { ...state, collection: action.payload };
        case WORKER_ACTION_TYPES.POST_WORKER_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case WORKER_ACTION_TYPES.PUT_WORKER_SUCCESS:
            const updatedWorker = action.payload;
            return { ...state, collection: state.collection.map((worker) => worker.uuid !== updatedWorker.uuid ? worker : { ...worker, ...updatedWorker }) };
        case WORKER_ACTION_TYPES.UPDATE_WORKERS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
